import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {html, type TemplateResult} from "lit";
import {GLOBAL} from "../../../common/globals";
import {EventBus} from "../../../common/eventBus";
import {resolve} from "../../../container";

export const SCROLL_PROGRESS_END = "scroll-progress-end";
export const SCROLL_PROGRESS_ENABLE_EVENT = "scroll-progress-enable";
export const SCROLL_PROGRESS_DISABLE_EVENT = "scroll-progress-disable";

@customElement("eop-scroll-progress-bar")
export class EopScrollProgressBar extends UnLitElement {

    @property({attribute: "sticky", type: Boolean, reflect: true})
    public sticky: boolean = false;
    @property({attribute: "inprogress", type: Boolean, reflect: true})
    public inProgress: boolean = false;
    @property({attribute: "enabled", type: Boolean, reflect: true})
    public enabled: boolean = false;

    public constructor(private eventBus: EventBus = resolve(EventBus)) {
        super();
    }

    private scrollHandler = (): void => this.updateProgress();

    public connectedCallback(): void {
        super.connectedCallback();

        GLOBAL.window().addEventListener("scroll", this.scrollHandler);
        this.eventBus.on(SCROLL_PROGRESS_ENABLE_EVENT, () => this.enabled = true);
        this.eventBus.on(SCROLL_PROGRESS_DISABLE_EVENT, () => this.enabled = false);
    }

    public disconnectedCallback(): void {
        GLOBAL.window().removeEventListener("scroll", this.scrollHandler);
        super.disconnectedCallback();
    }

    public render(): TemplateResult {
        return html`
            <div class="scroll-progress-bar"></div>
        `;
    }

    private updateProgress(): void {
        const scrollY = GLOBAL.window().scrollY;
        const startElementBottomY = this.determineStartElementBottomY();
        const endElementTopY = this.determineEndElementTopY();
        const scrollableDistance = endElementTopY - GLOBAL.window().innerHeight - startElementBottomY;
        const scrollProgress = scrollableDistance > 0 ? Math.min(1, Math.max(0, (scrollY - startElementBottomY) / scrollableDistance)) : 1;
        this.style.setProperty("--scroll-progress", String(scrollProgress));

        if (!this.inProgress && scrollProgress > 0 && this.isEnabledFromHeader()) {
            this.inProgress = true;
        } else if (this.inProgress && scrollProgress === 0 || !this.isEnabledFromHeader()) {
            this.inProgress = false;
        }
    }

    private determineStartElementBottomY(): number {
        const scrollY = GLOBAL.window().scrollY;
        const staticHeader = GLOBAL.document().querySelector<HTMLElement>("header:not(.sticky)");
        return staticHeader ? staticHeader.getBoundingClientRect().bottom + scrollY : 0;
    }

    private determineEndElementTopY(): number {
        const scrollY = GLOBAL.window().scrollY;
        const endSection = GLOBAL.document().querySelector<HTMLElement>(`section[${SCROLL_PROGRESS_END}]`);
        const footer = GLOBAL.document().querySelector<HTMLElement>("footer");
        const endElement = endSection ?? footer;
        return endElement ? endElement.getBoundingClientRect().top + scrollY : GLOBAL.document().body.scrollHeight;
    }

    private isEnabledFromHeader(): boolean {
        return this.sticky || this.enabled;
    }
}